<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" ref="child"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" ref="child"/>
  </div>
</template>

<script>

export default {
  name: 'defaultLayout',
  data () {
    return {
    }
  },
  methods: {
  },
}
</script>

<style lang="stylus">
</style>
